import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { useLayoutEffect } from 'react';

interface Props extends React.HTMLAttributes<HTMLUListElement> {
  ref?: React.Ref<HTMLUListElement>;
  className?: string;
  children: React.ReactNode;
}

/**
 * Menu - typicky pro dropdown menu.
 */
const Menu: React.FC<Props> = React.forwardRef<HTMLUListElement, Props>(
  ({ className, children, ...restProps }, ref) => {
    const internalRef = React.useRef<HTMLUListElement | null>(null);
    const usedClassName = classNames(Classes.MENU, className);

    useLayoutEffect(() => {
      if (internalRef?.current) {
        const activeItem = internalRef.current.querySelector(
          `.${Classes.ACTIVE}`
        );
        if (activeItem) {
          setTimeout(() => {
            activeItem.scrollIntoView({ behavior: 'auto', block: 'nearest' });

            if (internalRef.current) {
              const activeItemRect = activeItem.getBoundingClientRect();
              const menuRect = internalRef.current.getBoundingClientRect();
              const offset = activeItemRect.top - menuRect.top;
              internalRef.current?.scrollBy(0, offset > 0 ? 64 : -64);
            }
          }, 0);
        }
      }
    }, []);

    const setRef = (el: HTMLUListElement | null) => {
      internalRef.current = el;
      if (typeof ref === 'function') {
        ref(el);
      } else if (ref && typeof ref === 'object') {
        (ref as React.MutableRefObject<HTMLUListElement | null>).current = el;
      }
    };

    return (
      <ul ref={setRef} className={usedClassName} {...restProps}>
        {children}
      </ul>
    );
  }
);

export { Menu };
